module.exports = __webpack_public_path__ + "img/oscar_the_grouch.55651023.jpg";